import { createSpriteTexturePoint } from '../../tools/pixi_tools';
import { DataStore } from '../base/DataStore.js';

export default class Card {
     constructor(type,length){
        this.type=type;
        this.length=length||12
        this.dataStore = DataStore.getInstance();
		this.app = this.dataStore[`${type}_app`];
        this.resources = this.dataStore[`${type}_resources`];
        this.SW = this.app.SW;
		this.SH = this.app.SH;
     }

     create(){
        let container = new PIXI.Container();   
        let card =createSpriteTexturePoint({
            frameName:this.type+'_',
            frameLength:this.length,
            speed:.2,
            point:{x:0,y:0},
            loop:true,
            resource:this.resources
        });
        container.addChild(card)
        return  container
     }
}